import { render, staticRenderFns } from "./AssessmentInstitutionData.vue?vue&type=template&id=986c52a2"
import script from "./AssessmentInstitutionData.vue?vue&type=script&lang=js"
export * from "./AssessmentInstitutionData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports